<p>
  property-search-doc-image works!
</p>
